// engine
import { ArContainer, ArLayout, ArSprite, ORIENTATION } from '@aceroll/core';

// game-objects
import { BtnContinue } from '../game-objects/btn-continue';
import { GameLogo } from '../game-objects/game-logo';
import { SplashFeatures } from '../game-objects/popups/splash-features';

export default class Splash extends ArLayout {
	init() {
		super.init();
		this.volatilityBar = ArSprite.from('splash-volatility_ph');
		this.volatilityBar.anchor.set(.5, .5);
		this.btnContinue = new BtnContinue();

		this.bgContainer = new ArContainer('bgContainer');
		this.bgContainer.baseSize = {
			[ORIENTATION.LANDSCAPE]: {
				width: 2048,
				height: 2048
			},
			[ORIENTATION.PORTRAIT]: {
				width: 2048,
				height: 2048
			}
		};
		this.bgContainer.scaleMode = 'max';
		this.background = ArSprite.from('img-background-splash');

		this.background.anchor.set(0.5, 0.5);
		this.background.position.set(1024, 1024);
		this.bgContainer.addChild(this.background);
		this.gameLogo = new GameLogo();
		this.gameLogo.scale = .4;
		this.gameContainer = new ArContainer('splash-game-container');
		this.splashPopup = new SplashFeatures(this.orientation);
		this.gameContainer.addChild(
			this.splashPopup,
			this.gameLogo,
			this.volatilityBar,
			this.btnContinue
		);

		this.root.addChild(
			this.bgContainer,
			this.gameContainer
		);
	}

	onLandscape() {
		super.onLandscape();
		this.gameLogo.position.set(1170, 140);
		this.gameLogo.scale = .4;
		this.splashPopup.position.set(1170, 485);
		this.splashPopup.scale.set(1);
		this.splashPopup.setLandscape();
		this.btnContinue.position.set(1170, 1020);
		this.volatilityBar.position.set(1170, 250);
		this.volatilityBar.scale = .6;
	}

	onPortrait() {
		super.onPortrait();
		this.gameLogo.position.set(540, 350);
		this.gameLogo.scale = .6;
		this.volatilityBar.position.set(540, 510);
		this.volatilityBar.scale = .87;
		this.splashPopup.position.set(84, 1030);
		this.splashPopup.scale.set(2);
		this.splashPopup.setPortrait();
		this.btnContinue.position.set(540, 2140);

	}

	destroy() {
		this.splashPopup.hide();
		this.root.destroy({ children: true, texture: true, baseTexture: true });
	}

	get orientation() {
		return this.isPortrait ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE;
	}
}
